import { ReactElement, useCallback } from 'react';
import { createFetchContext } from '../../../../../../components/contexts/FetchContextFactory';
import { getAssignedStudents } from '../api';
import {
  AssignedStudentsPaginationQuery,
  AssignedStudentsType,
} from '../types';

export interface BaseLoaderProps {
  teacherId: string;
  children: ReactElement;
}

const { FetchProvider, FetchConsumer, useFetch } = createFetchContext<
  AssignedStudentsPaginationQuery,
  AssignedStudentsType
>();

export const BaseLoaderConsumer = FetchConsumer;
export const useAssignedStudentsTableLoader = useFetch;

export const TOTAL_ITEMS_PER_PAGE = 10;

export default function AssignedStudentsTableLoader({
  teacherId,
  children,
}: BaseLoaderProps) {
  const request = useCallback(
    (query) => {
      return getAssignedStudents({ ...query, page: query.page - 1 }, teacherId);
    },
    [teacherId],
  );

  return (
    <FetchProvider
      request={request}
      defaultQuery={{ page: 1, items_per_page: TOTAL_ITEMS_PER_PAGE }}
      fetchImmediately
    >
      {children}
    </FetchProvider>
  );
}
